"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeGapShorthand = exports.openGapShorthand = void 0;
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var getGapShorthandParts = function () {
    return [
        {
            prop: 'row-gap',
            dataType: css_data_types_1.lengthPercentageDataType,
            partOpener: (0, shorthand_parser_utils_1.splitSimpleShorthandOpener)(['row-gap', 'column-gap']),
        },
        {
            prop: 'column-gap',
            dataType: css_data_types_1.lengthPercentageDataType,
        },
    ];
};
// gap
var openGapShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'gap',
        parts: getGapShorthandParts(),
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openGapShorthand = openGapShorthand;
var closeGapShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.createShorthandCloserTemplateFromParts)(getGapShorthandParts()));
};
exports.closeGapShorthand = closeGapShorthand;
//# sourceMappingURL=gap-shorthand.js.map